import { forwardRef } from 'react'
import { StyleProp, TextInput, View, ViewStyle } from 'react-native'
import { HelperText, TextInputProps } from 'react-native-paper'

type MelddTextInputProps = TextInputProps & {
  wrapperStyle?: StyleProp<ViewStyle>
  helperText?: string
}

const MelddTextInput = forwardRef<TextInput, MelddTextInputProps>(
  ({ ...props }, ref) => {
    const { wrapperStyle, error, helperText, ...textInputProps } = props
    return (
      <View style={wrapperStyle}>
        <TextInput ref={ref} {...textInputProps} />
        <HelperText type={error ? 'error' : 'info'} visible={!!helperText}>
          {helperText}
        </HelperText>
      </View>
    )
  }
)

export default MelddTextInput
